import React from "react";

const Toggle = (props) => {
    return (
        <div className={`toggle`}>
            <input type="checkbox" id={props.id} name={props.name}/>
        </div>
    );
}
export default Toggle;